import React, { createContext, useContext, useState } from 'react'
import { IFMIBulkSelectInstructorsContext, IFMIBulkSelectInstructorsProvider, ISort } from './interface'

export const FMIBulkSelectInstructorsContext = createContext<IFMIBulkSelectInstructorsContext | null>(null)

export const useFMIBulkSelectInstructorsHook = () => {
  const [selectAll, setSelectAll] = useState(false)
  const [sort, setSort] = useState<ISort>('asc')
  const [selectedInstructorIds, setSelectedInstructorIds] = useState<string[]>([])

  return {
    selectAll,
    setSelectAll,
    sort,
    setSort,
    selectedInstructorIds,
    setSelectedInstructorIds,
  }
}

export const FMIBulkSelectInstructorsProvider: React.FC<IFMIBulkSelectInstructorsProvider> = ({ children }) => {
  return (
    <FMIBulkSelectInstructorsContext.Provider value={useFMIBulkSelectInstructorsHook()}>
      {children}
    </FMIBulkSelectInstructorsContext.Provider>
  )
}

export const useFMIBulkSelectInstructors = (): IFMIBulkSelectInstructorsContext => {
  const context = useContext(FMIBulkSelectInstructorsContext)
  if (context === null) {
    throw new Error('useFMIBulkSelectInstructors must be used within a FMIBulkSelectInstructorsProvider')
  }
  return context
}
